export default __webpack_public_path__ + "301685dd1b213cfb7f5b61b6219853db.svg";